<div class="p-3 root">
    @if (config.searchable) {
        <div class="pb-2">
            <key-search [(searchValue)]="searchValue" [placeholder]="'SHARED.SEARCH_ELLIPSES' | translate" (submitSearch)="submitSearch($event)" (clear)="clearSearch()">
            </key-search>
        </div>
    }

    @if (selectedItems.length > 0) {
        <div class="border-bottom mb-2 pb-2">
            @for (item of selectedItems; track item) {
                <div>
                    <label class="form-check-label" (click)="itemDeselected(item)">
                        <span [ngStyle]="{ 'padding-left': item.level * 18 + 'px' }"></span>
                        <input [checked]="true" kui-checkbox /> {{ item.name }}
                    </label>
                </div>
            }
        </div>
    }

    <div class="item-list">
        @for (item of deselectedItems; track item) {
            <div>
                <label class="form-check-label" (click)="itemSelected(item)">
                    <span [ngStyle]="{ 'padding-left': item.level * 18 + 'px' }"></span>
                    <input [checked]="false" kui-checkbox /> {{ item.name }}
                </label>
            </div>
        }

        @if (deselectedItems.length === 0) {
            <div>{{ "SHARED.NO_MORE_ITEMS" | translate }}</div>
        }
    </div>
</div>
